import {
  AnnotationsPlugin,
  BCFViewpointsPlugin,
  CameraMemento,
  ContextMenu,
  //DistanceMeasurementEditMouseControl,
  DistanceMeasurementsMouseControl,
  DistanceMeasurementsPlugin,
  DistanceMeasurementsTouchControl,
  FastNavPlugin,
  GLTFLoaderPlugin,
  LASLoaderPlugin,
  math,
  ModelMemento,
  NavCubePlugin,
  OBJLoaderPlugin,
  //PointerLens,
  SectionPlanesPlugin,
  STLLoaderPlugin,
  ViewCullPlugin,
  Viewer,
  XKTLoaderPlugin,
} from '@xeokit/xeokit-sdk';

import { PointerCircle } from '@xeokit/xeokit-sdk/src/extras/PointerCircle/PointerCircle.js';
import {
  DistanceMeasurementEditMouseControl,
  DistanceMeasurementEditTouchControl,
} from '@xeokit/xeokit-sdk/src/plugins/DistanceMeasurementsPlugin/index.js';
import { touchPointSelector } from '@xeokit/xeokit-sdk/src/plugins/lib/ui';
import { os } from '@xeokit/xeokit-sdk/src/viewer/utils/os.js';
import { StoreyViewsPlugin } from '@xeovision/storey-views-plugin';

import {
  ZoneEditMouseControl,
  ZonesMouseControl,
  ZonesPlugin,
  ZoneTranslateMouseControl,
} from '@xeokit/xeokit-sdk/src/plugins/ZonesPlugin';

import { DotBIMLoaderPlugin } from '@xeokit/xeokit-sdk/src/plugins/DotBIMLoaderPlugin/DotBIMLoaderPlugin.js';
import { XeoIFCLoaderPlugin } from '@xeofoundrybim/xeoifc-loader-plugin';

import { utils } from '@xeokit/xeokit-sdk/src/viewer/scene/utils';
import { PointerLens } from '~/utils/viewer/tools/pointer-lens';

export default defineNuxtPlugin(() => {
  return {
    provide: {
      Viewer,
      FastNavPlugin,
      NavCubePlugin,
      ContextMenu,
      CameraMemento,
      ModelMemento,
      StoreyViewsPlugin,
      PointerLens,
      DistanceMeasurementsPlugin,
      SectionPlanesPlugin,
      BCFViewpointsPlugin,
      DistanceMeasurementsMouseControl,
      DistanceMeasurementsTouchControl,
      DistanceMeasurementEditMouseControl,
      DistanceMeasurementEditTouchControl,
      ViewCullPlugin,
      ZonesPlugin,
      ZoneTranslateMouseControl,
      ZonesMouseControl,
      ZoneEditMouseControl,

      AnnotationsPlugin,
      PointerCircle,
      touchPointSelector,

      math,
      os,

      XKTLoaderPlugin,
      LASLoaderPlugin,
      OBJLoaderPlugin,
      STLLoaderPlugin,
      GLTFLoaderPlugin,
      DotBIMLoaderPlugin,
      XeoIFCLoaderPlugin,

      utils,
    },
  };
});

export type ViewerType = InstanceType<typeof Viewer>;
export type XKTLoaderPluginType = InstanceType<typeof XKTLoaderPlugin>;
export type SectionPlanesPluginType = InstanceType<typeof SectionPlanesPlugin>;
export type BCFViewpointsPluginType = InstanceType<typeof BCFViewpointsPlugin>;
export type AnnotationsPluginType = InstanceType<typeof AnnotationsPlugin>;
export interface AnnotationDto {
  id: string;
  glyph: string;
  title: string;
  description: string;
  color: string;
  worldPos: number[];
}
